import useHasExperiment from ':cloud/hooks/useHasExperiment';

export function useIdentityNavigationExperiment() {
  const isTreatment = useHasExperiment('dec_2023_identity_navigation_cloud', 'treatment');

  return isTreatment;
}
